import { HttpClient } from '@angular/common/http';
import { ResponseObject } from '@app/shared/models/response-object';
import { Observable, catchError, map, retry } from 'rxjs';

export class LimitFeatureApi {
  apiUrl = '../../assets/mock/limit-feature-feature.json';
  constructor(public readonly http: HttpClient) {}

  // mock data
  getAllLimitFeature(): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(this.apiUrl).pipe(
      retry(1),
      map((res: any) => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }
}
